var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow",
        },
      ],
      staticClass: "sweiper_item",
      class: {
        sweiper_card: _vm.$parent.type === "card",
        "is-active": _vm.active,
        "is-in-stage": _vm.inStage,
      },
      style: _vm.itemStyle,
    },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.active,
            expression: "!active",
          },
        ],
        staticClass: "nsweiper_mask",
      }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }